const ErorrMsg = props => {
    return <p className="err-msg">{props.children}</p>;
}

export default ErorrMsg;